import React, { memo, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useAsyncDispatchWithErrorToast } from './hooks/useAsyncDispatchWithErrorToast'
import { FetchDriver, FetchPartner, FetchRemoteConfig } from './constants/actionTypes'
import { Driver } from './interfaces/driver'

export const ClientSecureHooksContainer = memo(() => {
  const { asyncDispatchWithErrorToast } = useAsyncDispatchWithErrorToast('client')
  const dispatch = useDispatch()

  // Plain dispatch, not the toast: a failed load keeps the built-in values and shows nothing.
  useEffect(() => {
    dispatch(FetchRemoteConfig.request({ platform: 'client' }))
  }, [dispatch])

  useEffect(() => {
    const initUser = async () => {
      try {
        await asyncDispatchWithErrorToast<Driver>(FetchDriver.request(), true)
        await asyncDispatchWithErrorToast(FetchPartner.request(), true)
      } catch {}
    }

    initUser()
  }, [])

  return null
})
